'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _store = require('../store');

var _store2 = _interopRequireDefault(_store);

var _vuex = require('vuex');

var _vuePositionSticky = require('vue-position-sticky');

var _vuePositionSticky2 = _interopRequireDefault(_vuePositionSticky);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuePositionSticky2.default);

exports.default = {
  store: _store2.default,
  props: ['assessmentId', 'isSimulation', 'submitAssessmentUrl', 'submitQuestionUrl', 'submitQuestionCommentUrl', 'getUrl', 'exitUrl', 'commentTitle', 'questionCommentTitle', 'questionCommentTooltip', 'categoryErrorTitle', 'categoryErrorBody'],

  data: function data() {
    return {
      loading: false
    };
  },


  computed: _extends({}, (0, _vuex.mapState)(['categories', 'activeCategory', 'questionLoading']), (0, _vuex.mapGetters)(['getResultSimulationInfo', 'getAnswers', 'getComments', 'getAssessmentId', 'getActiveCategoryId', 'getCurrentCategoryComment', 'getQuestions']), {
    firstCategory: function firstCategory() {
      return this.activeCategory === 0;
    },
    lastCategory: function lastCategory() {
      return this.activeCategory === this.categories.length - 1;
    },
    notFirstOrLastCategory: function notFirstOrLastCategory() {
      return !this.firstCategory && !this.lastCategory;
    }
  }),

  mounted: function mounted() {
    var urlPayload = {
      getUrl: this.getUrl,
      submitQuestionUrl: this.submitQuestionUrl,
      submitQuestionCommentUrl: this.submitQuestionCommentUrl,
      submitAssessmentUrl: this.submitAssessmentUrl,
      exitUrl: this.exitUrl
    };
    this.setUrls(urlPayload);

    var categoryPayload = {
      assessmentId: this.assessmentId
    };
    this.loadAssessment(categoryPayload);
  },

  methods: _extends({}, (0, _vuex.mapActions)(['submitAssessment', 'loadAssessment', 'setUrls']), (0, _vuex.mapMutations)(['submitQuestion', 'setQuestion', 'setCategory', 'setCategoryComment', 'setQuestionsValidity']), {
    showComment: function showComment(categoryId) {
      return this.getQuestionsOfCategory(categoryId).length > 0;
    },
    printAssessment: function printAssessment() {
      window.print();
    },
    saveAssessment: function saveAssessment() {
      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'exit';


      if (this.questionLoading === true) {
        this.$notify({
          type: 'error',
          title: this.categoryErrorTitle,
          message: this.categoryErrorBody,
          offset: 150
        });
        return false;
      }

      var self = this;
      self.loading = true;

      var payload = {
        currentCategoryId: this.getActiveCategoryId,
        currentCategoryComment: this.getCurrentCategoryComment,
        assessmentId: this.getAssessmentId,
        action: action
      };

      var promise = this.submitAssessment(payload);
      promise.then(function (response) {
        self.loading = false;

        var success = response.data.success;
        if (success === true) {

          switch (action) {
            case 'next':
              self.nextCategory();
              break;
            case 'previous':
              self.previousCategory();
              break;
            case 'confirm':
              self.confirmAssessment();
              break;
            case 'exit':
              self.exitAssessment();
              break;
          }
        } else if (success === false) {
          self.$notify({
            title: 'Error',
            message: 'Not all answers are filled in',
            type: 'error',
            offset: 150
          });

          var _payload = {
            questionValidations: response.data.customData.questionValidations
          };

          self.setQuestionsValidity(_payload);
        }
      }).catch(function (error) {
        if (error.response !== undefined && error.response.status >= 500 || error.message === "Network Error") {
          self.$notify({
            title: 'Update failed',
            message: 'Due to network or server problems, your request could not be processed. Please try again later.',
            type: 'error',
            offset: 150
          });
        } else {
          console.error(error);
        }
      });
    },
    confirmAssessment: function confirmAssessment() {

      this.$notify({
        title: 'Success',
        type: 'success',
        offset: 150
      });

      location.reload(true);
    },
    exitAssessment: function exitAssessment() {
      window.location = this.exitUrl;
    },
    nextCategory: function nextCategory() {
      if (this.activeCategory + 1 <= this.categories.length - 1) {
        this.setCategory(this.activeCategory + 1);
      }
    },
    previousCategory: function previousCategory() {
      if (this.activeCategory - 1 >= 0) {
        this.setCategory(this.activeCategory - 1);
      }
    },
    getQuestionsOfCategory: function getQuestionsOfCategory() {
      var category = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.activeCategory;

      return this.categories[category].questions;
    }
  })
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./public/js/components/assessment.vue
// module id = ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./public/js/components/assessment.vue
// module chunks = 0